// extracted by mini-css-extract-plugin
export default {"main_div":"CustomTable_main_div__h14ni"};